import api from '../../../lib/api'
import type { CallLog, Reminder } from '../../../types'

export const telephonyService = {
  async getMyCallLogs(): Promise<CallLog[]> {
    const { data } = await api.get('/calls/my-logs')
    return data
  },

  async getAllCallLogs(): Promise<CallLog[]> {
    const { data } = await api.get('/calls/all-logs')
    return data
  },

  async getLatestCallForLead(leadId: number): Promise<CallLog | null> {
    try {
      const { data } = await api.get(`/calls/lead/${leadId}/latest`)
      return data
    } catch {
      return null
    }
  },

  async getMyReminders(): Promise<Reminder[]> {
    const { data } = await api.get('/calls/reminders')
    return data
  },

  async createReminder(payload: {
    lead_id: number
    reminder_at: string
    note?: string
    source?: 'MANUAL' | 'SYSTEM_PROMPTED'
  }): Promise<Reminder> {
    const { data } = await api.post('/calls/reminders', payload)
    return data
  },

  async completeReminder(reminderId: number): Promise<void> {
    await api.patch(`/calls/reminders/${reminderId}/complete`)
  },

  /** Telecaller was prompted to set a follow-up reminder and declined — reason required. */
  async declineReminder(callId: number, reason: string): Promise<void> {
    await api.post(`/calls/${callId}/decline-reminder`, { reason })
  },

  async getCallLog(callLogId: number): Promise<CallLog> {
    const { data } = await api.get(`/telephony/calls/${callLogId}`)
    return data
  },

  async reanalyzeCall(callLogId: number): Promise<void> {
    await api.post(`/telephony/calls/${callLogId}/reanalyze`)
  },

  async getRecordingConfig(): Promise<{ call_recording_mode: string; android_oem: string }> {
    const { data } = await api.get('/telephony/recording-config')
    return data
  },

  async uploadNativeRecording(callLogId: number, file: File): Promise<void> {
    const form = new FormData()
    form.append('file', file)
    await api.post(`/telephony/calls/${callLogId}/recording`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
}
